import React from 'react';
import { FailedIcon, SuccessIcon } from '@common/utils/icons/icons';
import MissionEndStatus from '../../models/enums/mission-status';

const StatusIcon: React.FC<{ status: MissionEndStatus }> = ({ status }) => {
  return (
    <React.Fragment>
      {status === MissionEndStatus.SUCCEEDED ? (
        <SuccessIcon color="success" />
      ) : status === MissionEndStatus.SUCCEEDED_WITH_ERROR ? (
        <FailedIcon color="success" />
      ) : status === MissionEndStatus.FAILED ? (
        <FailedIcon color="error" />
      ) : (
        <FailedIcon color="warning" />
      )}
    </React.Fragment>
  );
};

export default StatusIcon;
